export const ORDERS_QUERY_KEY = {
  all: ['orders'] as const,
  list: () => [...ORDERS_QUERY_KEY.all] as const,
  detail: (id: number) => [...ORDERS_QUERY_KEY.all, id] as const,
};
